import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import { paginatedRemove, useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { PriceAlertDetailsModel } from "@/features/priceAlerts/api/models/PriceAlertDetailsModel";

export const usePriceAlertDelete = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<PriceAlertDetailsModel>, string> = priceAlertId => {
		return http({
			method: "DELETE",
			url: `/price-alert/${priceAlertId}`
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (_, priceAlertId) => {
			queryClient.setQueryData(["priceAlertDetails"], paginatedRemove<PriceAlertDetailsModel>(x => x.priceAlertId === priceAlertId));
		}
	});
};
